// @ts-ignore:next-line
import Values from "values.js";

/**
 * Helper function to lighten the base color by mixing it with white as specified by percentage.
 *
 *
 * @param {string} color - a valid CSS color string
 * @param {number} percentage - the percent of the lightness. Should be between 0 and 100.
 */
export const lightenColor = (color: string, percentage: number) => {
  const colorValue = new Values(color);
  const hex = `#${colorValue.tint(percentage).hex}`;
  return hex;
};

/**
 * Helper function to darken the base color by mixing it with black as specified by percentage.
 *
 *
 * @param {string} color - a valid CSS color string
 * @param {number} percentage - the percent of the darkness. Should be between 0 and 100.
 */
export const darkenColor = (color: string, percentage: number) => {
  const colorValue = new Values(color);
  const hex = `#${colorValue.shade(percentage).hex}`;
  return hex;
};
